import { render, staticRenderFns } from "./SupplierQuality.vue?vue&type=template&id=cb4124bc&scoped=true&lang=true"
import script from "./SupplierQuality.vue?vue&type=script&lang=js"
export * from "./SupplierQuality.vue?vue&type=script&lang=js"
import style0 from "./SupplierQuality.vue?vue&type=style&index=0&id=cb4124bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb4124bc",
  null
  
)

export default component.exports